/**
 * Small reusable UI components used across the warranty class detail tabs.
 */

import { Button } from '@/shared/components/ui/button'

export function GreenButton({
  children,
  onClick,
  disabled,
}: {
  children: React.ReactNode
  onClick: () => void
  disabled?: boolean
}) {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      className="h-auto cursor-pointer rounded-[4px] bg-[var(--green)] px-4 py-1.5 text-[11px] uppercase tracking-[0.1em] text-[var(--bg)] transition-all duration-150 hover:bg-[var(--green-hover)] disabled:opacity-40"
    >
      {children}
    </Button>
  )
}

export function TypeBadge({ children }: { children: React.ReactNode }) {
  return (
    <span className="inline-flex items-center rounded-full bg-[var(--bg-subtle)] px-2 py-0.5 text-[10px] uppercase tracking-[0.06em] text-[var(--ink-3)]">
      {children}
    </span>
  );
}

export function IconButton({
  children,
  onClick,
  title,
}: {
  children: React.ReactNode
  onClick: () => void
  title: string
}) {
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={onClick}
      title={title}
      className="h-6 w-6 cursor-pointer items-center justify-center rounded-[4px] text-[var(--ink-3)] transition-all duration-150 hover:bg-[var(--bg-subtle)]"
    >
      {children}
    </Button>
  )
}

export function SectionHeader({ children }: { children: React.ReactNode }) {
  return (
    <h2 className="mb-3 border-b-[0.5px] border-[var(--rule)] pb-2 text-[10px] font-normal uppercase tracking-[0.12em] text-[var(--ink-3)]">
      {children}
    </h2>
  )
}
